module.exports = __webpack_public_path__ + "static/media/10sec_forward-512.972545aa.png";